module.exports = __webpack_public_path__ + "/images/cover-sorteo.9573fbc.png";